export const irrigationEs = {
  dualKcOnboarding: {
    title: "Registro de evidencia hídrica (Dual Kc)",
    subtitle: "Supervisado. Usted registra lo que ocurrió realmente en campo; nada se supone por usted.",
    disclaimer: "Los valores declarados se etiquetan como declarados, nunca como medidos. Lo que falta permanece desconocido y el balance FAO-56 Dual Kc se bloquea en lugar de suponer.",
    saved: "Evidencia registrada",
    readyNote: "Toda la evidencia requerida está presente. La siguiente ejecución programada de Dual Kc podrá continuar.",
    currentChainComplete: "Cadena de evidencia Dual Kc completa para esta fecha de cálculo.",
    oneTime: "Configuración inicial",
    ongoing: "Continuo (diario)",
    status: {
      ready: "Listo",
      needs_initialization: "Falta inicialización",
      needs_irrigation_evidence: "Falta evidencia de riego",
      blocked: "Bloqueado",
      invalid: "No válido",
    },
    notesPlaceholder: "Nota opcional (máx. 500 caracteres)",
    unit: {
      mm: "mm",
      m3_ha: "m³/ha",
      l_ha: "l/ha",
      m3_total: "m³ (total)",
      l_total: "litros (total)",
    },
    error: {
      generic: "No se pudo registrar esta evidencia.",
      not_authenticated: "Vuelva a iniciar sesión.",
      invalid_input: "Revise el valor introducido.",
      taw_unknown: "No se conoce la capacidad de agua del suelo (TAW) de esta parcela, por lo que aún no puede validarse un agotamiento en mm.",
      dr_above_taw: "El agotamiento declarado no puede superar el agua total disponible de la zona radicular.",
      amount_not_convertible: "Esta cantidad no puede convertirse a mm con la información proporcionada.",
      irrigation_system_unknown: "Documente el sistema de riego de la parcela antes de declarar una fracción de suelo mojada.",
      fw_out_of_range: "Introduzca una superficie de suelo mojada entre 1% y 100%.",
    },
    input: {
      crop_identification: {
        question: "¿Qué cultivo hay en esta parcela?",
        why: "El cultivo determina la profundidad radicular, el Kc y la fracción de agotamiento.",
        short: "Cultivo identificado",
        action: "Indique el tipo de cultivo en la ficha de la parcela para continuar.",
      },
      soil_water_capacity: {
        question: "La capacidad de agua del suelo aún no está disponible",
        why: "El agua total disponible (TAW) es necesaria para interpretar cualquier agotamiento.",
        short: "Capacidad de agua del suelo",
        action: "Añada un análisis de suelo o espere a que el sistema resuelva la evidencia edáfica de esta parcela.",
      },
      weather_evidence: {
        question: "No hay evidencia meteorológica para esta fecha",
        why: "La ET₀ debe existir antes de calcular el balance hídrico del cultivo.",
        short: "Evidencia meteorológica",
        action: "Todavía no hay datos meteorológicos de proveedor registrados para esta fecha.",
      },
      surface_wetting_confirmation: {
        question: "¿Se humedeció completamente la superficie del suelo hoy (riego o lluvia abundante)?",
        why: "Es la única forma aprobada de iniciar el estado de evaporación superficial (De).",
        short: "Humectación superficial confirmada",
        confirm: "Sí, la superficie se humedeció completamente hoy",
      },
      irrigation_system_evidence: {
        question: "¿Qué sistema de riego utiliza esta parcela?",
        why: "El sistema de riego es evidencia. Mientras se desconozca, no puede introducirse ni suponerse ninguna fracción de suelo mojada.",
        short: "Sistema de riego documentado",
        helper: "Confirme o actualice el sistema de riego en la ficha de la parcela. Un sistema desconocido nunca se interpreta como aspersión.",
        configure: "Abrir configuración de la parcela",
      },
      wetted_fraction_evidence: {
        question: "¿Qué fracción de la superficie del suelo moja realmente el riego?",
        why: "FAO-56 necesita la fracción de suelo mojada (fw). Nunca se deriva del tipo de sistema de riego.",
        short: "Fracción de suelo mojada",
        label: "Superficie de suelo mojada (%)",
        helper: "Introduzca un valor solo si lo conoce por observación en campo, documentación del sistema de riego o una fuente medida o verificada. Si no lo conoce, no lo estime: dejarlo desconocido mantiene bloqueado el cálculo Kc dual.",
        declare: "Guardar fracción mojada declarada",
        unknown: "No lo sé",
        unknownToast: "No se guardó nada. La fracción de suelo mojada sigue siendo desconocida y el cálculo Kc dual permanece bloqueado.",
        declaredNote: "Declarado por el productor: evidencia de calidad limitada, no medida y no válida para validación independiente.",
      },
      root_zone_initialization: {
        question: "¿Cuánta agua falta hoy en la zona radicular?",
        why: "El agotamiento radicular (Dr) necesita un punto de partida real; nunca se supone.",
        short: "Zona radicular inicializada",
        drLabel: "Agotamiento de la zona radicular (mm)",
        declare: "Registrar agotamiento declarado",
        fieldCapacity: "La zona radicular se rellenó completamente hoy",
        declaredNote: "Un agotamiento declarado se registra como evidencia declarada de calidad limitada, nunca como medición.",
      },
      irrigation_evidence: {
        question: "¿Se aplicó riego en esta parcela en la fecha indicada?",
        why: "La ocurrencia y la cantidad son hechos distintos; una cantidad desconocida nunca se trata como 0 mm.",
        short: "Evidencia diaria de riego",
        dateLabel: "Fecha: {{date}}",
        amount: "Cantidad aplicada",
        system: "Sistema de riego (opcional)",
        applied: "Registrar riego aplicado",
        none: "No se aplicó riego",
        amountUnknown: "No sé la cantidad",
        enterAmount: "Introducir la cantidad",
        uncertain: "No estoy seguro",
        unknownNote: "Si la cantidad es desconocida, el balance se bloquea ese día en lugar de suponer una lámina.",
      },
    },
  },
  irrigationPage: {
    title: "Gestor de Riego",
    subtitle: "Optimiza el uso del agua con cálculos científicos de ET0"
  },
  irrigationOptimizer: {
    title: "Optimizador de Riego",
    premiumFeature: "La optimización de riego es una función premium. Actualiza para acceder a la gestión de agua con IA.",
    upgradeToAccess: "Actualizar para Acceder",
    fao56Method: "Método de Cálculo FAO-56",
    fao56MethodDesc: "Elige entre la demanda de referencia con Kc Simple y el balance hídrico Kc Dual sujeto a evidencia.",
    method: "Método",
    kcSourceBadge: "Kc: valores de referencia FAO-56 Tabla 12 (Allen et al. 1998) — fuente de referencia, sin validación de campo",
    et0ConcordanceBadge: "ET₀ Penman-Monteith: solo comprobación de concordancia entre modelos — sin validación de campo independiente",
    singleKcValidated: "Kc Simple — demanda de referencia",
    dualKcBeta: "Kc Dual 🧪 Beta",
    dualKcValidated: "Kc Dual — implementado (sujeto a evidencia)",
    singleKcDesc: "Método de referencia FAO-56 con coeficientes de cultivo tabulados. Proporciona la demanda hídrica de referencia del cultivo cuando existe evidencia de cultivo, fenología y ETo; no es demanda de riego validada en campo.",
    dualKcDesc: "Método FAO-56 de balance hídrico Kc Dual. La implementación está sujeta a evidencia; la validación de campo independiente está pendiente.",
    fieldValidationPending: "Validación de Campo Pendiente",
    refresh: "Actualizar",
    aiPoweredDesc: "Recomendaciones de gestión de agua con IA para tus parcelas",
    weatherDataSources: "Fuentes de Datos Meteorológicos",
    weatherDataSourcesDesc: "La evidencia meteorológica se selecciona por variable a partir de la cadena de proveedores aprobada, por lo que un mismo cálculo puede combinar proveedores. El proveedor realmente utilizado en cada variable se muestra en el detalle de evidencia.",
    operationalGrid: "Cuadrícula Operacional",
    operationalGridDesc: "Decisiones calculadas en celdas de ~55×55m (base NDVI a 10m; agregado para robustez y gestión).",
    expectedAccuracy: "Estado de la evidencia",
    expectedAccuracyDesc: "ET₀ dispone de una comprobación operativa de concordancia entre modelos. Las salidas de riego con Kc Simple y Kc Dual todavía no tienen métricas de precisión de validación de campo independiente.",
    optimalRange: "Rango Óptimo",
    optimalRangeDesc: "2-20 ha para mejor precisión. Parcelas <1 ha: se recomienda complementar con sensores locales.",
    criticalNote: "Para decisiones críticas de riego, validar con agrónomo y sensores de campo.",
    analyzingNeeds: "Analizando necesidades de riego...",
    noParcelsFound: "No se encontraron parcelas. Añade una parcela para empezar.",
    noParcelsToast: "Sin parcelas encontradas",
    noParcelsToastDesc: "Añade parcelas primero para generar planes de riego",
    plansCalculated: "Planes de riego {{method}} calculados",
    analysisComplete: "Análisis {{method}} de parcelas completado",
    analysisCompleteDesc: "{{success}} calculadas · {{blocked}} bloqueadas",
    analysisCompleteDescWithErrors: "{{success}} calculadas · {{blocked}} bloqueadas · {{errors}} errores",
    plansCalculatedDesc: "Analizadas {{count}} parcela(s) usando método FAO-56 {{methodFull}}",
    errorLoadingPlans: "Error al cargar planes de riego",
    selectParcel: "Seleccionar parcela",
    allParcels: "Todas las parcelas",
    parcelCount: "{{count}} parcela(s)",
    blockedInvalidEtc: "Cálculo de riego bloqueado — ETc inválida. Revisar ciclo del cultivo, fecha de siembra/cosecha o parámetros FAO-56.",
    forecastUnavailable: "Previsión no disponible — ajuste no calculado.",
    adjHighDemand: "Alta demanda atmosférica (ET₀ elevada / calor)",
    adjElevatedDemand: "Demanda atmosférica elevada (ET₀ / temperatura)",
    adjNormalDemand: "Demanda atmosférica en rango normal"
  },
  irrigationPlan: {
    waterStressLevel: "Nivel de Estrés Hídrico",
    adjustedFor: "ajustado para {{season}}",
    requiresSatelliteData: "Requiere datos satelitales (NDVI/NDWI)",
    highStress: "Alto",
    moderateStress: "Moderado",
    lowStress: "Bajo",
    stress: "Estrés",
    temperature: "Temperatura",
    humidity: "Humedad",
    frequency: "Frecuencia",
    asNeeded: "Según necesidad",
    next3DaysAdjustments: "Ajustes Próximos 3 Días",
    weekly: "Semanal",
    monthly: "Mensual",
    yearly: "Anual",
    satelliteStressIndicator: "Indicador de estrés satelital/climático",
    satelliteStressIndicatorHelper: "Indicador independiente derivado de NDVI/NDWI de Sentinel-2 frente a umbrales estacionales del cultivo (0,6 x estrés NDVI + 0,4 x estrés NDWI). No es el coeficiente FAO-56 de estrés radicular Ks y no describe el agotamiento actual del agua del suelo.",
    estimatedCropWaterDemand: "Demanda hídrica estimada del cultivo",
    estimatedCropWaterDemandHelper: "Solo estimación de referencia (ETc = Kc x ET₀, Kc único). No es una instrucción para aplicar este volumen: el balance hídrico del suelo actual no está disponible.",
    vriReferenceHelper: "Las zonas expresan únicamente vigor NDVI relativo. No se prescribe ninguna lámina ni volumen de riego por zona.",
    canonicalBalanceUnavailableTitle: "Balance hídrico del suelo actual no disponible",
    canonicalBalanceUnavailableBody: "El balance hídrico FAO-56 Dual Kc con evidencia verificada no tiene resultado válido para hoy, por lo que no puede darse una instrucción de riego supervisada. Lo siguiente es únicamente una estimación de demanda hídrica de referencia.",
    dualKcDemandLine: "Balance hídrico canónico Kc Dual: ETc ≈ {{mm}} mm/día — revisar en campo antes de regar",
    noSavingsClaimTitle: "No se reclama ningún ahorro de agua ni económico",
    noSavingsClaimBody: "Un ahorro exige una línea base de riego medida en esta parcela. No existe, por lo que no se muestra ningún ahorro modelizado en €/litros.",
    zoneRelativeVigour: "Clase relativa de vigor NDVI — no se prescribe lámina de riego por zona",
    referenceDemandLine: "Demanda hídrica de referencia: ~{{mm}} mm/día (estimación Kc único, no es un balance hídrico actual)",
    vriZones: "Zonas de Riego Variable (VRI)",
    vriZonesUnavailableTitle: "Zonas VRI no disponibles",
    vriZonesUnavailableBody: "No se han podido calcular las zonas de Riego Variable para esta parcela en este momento (sin zonificación NDVI utilizable libre de nubes). El contorno de la parcela está registrado y sigue siendo válido.",
    vriBoundaryRequiredTitle: "Contorno de parcela requerido",
    vriBoundaryRequiredBody: "Se requieren coordenadas de polígono reales para la zonificación basada en NDVI. Dibuja el contorno de tu parcela en el mapa para habilitar las zonas de Riego Variable.",
    faoBlockedTitleDual: "Balance hídrico Dual Kc no disponible",
    faoBlockedTitleSingle: "Cálculo Single Kc no disponible",
    faoBlockedStatus: "Estado",
    faoBlockedSafeNextStep: "Siguiente paso seguro",
    faoBlockedDate: "Fecha de cálculo",
    faoBlockedIndependentNote: "Esto bloquea únicamente el balance hídrico FAO-56. El NDVI/NDWI satelital, el indicador de estrés, la geometría de la parcela y las zonas VRI son evidencia independiente y siguen siendo válidos donde se muestran.",
    faoErrorTitle: "Error de cálculo",
    zones: "{{count}} zonas",
    scientificMethod: "Método Científico",
    recommendations: "Recomendaciones",
    certifyAgronomicData: "Certificar Datos Agronómicos",
    blockchainProof: "Sello de integridad SHA-256 (Early Access)",
    insuranceClaims: "Reclamaciones de seguros",
    regulatoryAudits: "Auditorías regulatorias",
    premiumTraceability: "Trazabilidad premium",
    needProfessionalGuidance: "¿Necesitas Orientación Profesional?",
    scheduleConsultationDesc: "Programa una consulta con agrónomos certificados para validar planes de riego y optimizar tu estrategia de gestión del agua.",
    scheduleConsultation: "Programar Consulta con Agrónomo",
    dualKcBreakdownTitle: "Método Kc Dual (FAO-56 Cap. 7) — desglose de Kcb, Ke y Ks",
    cropEvapotranspirationLabel: "Evapotranspiración del cultivo (ETc)",
    referenceDemandParcelEquivalent: "Equivalente a escala de parcela: ~{{liters}} L/día. Es una equivalencia del uso de agua modelado del cultivo, no una cantidad a aplicar.",
    demandTrendHigher: "Mayor demanda atmosférica",
    demandTrendLower: "Menor demanda atmosférica",
    demandTrendStable: "Demanda atmosférica estable",
    actionsBlockedTitle: "Guardar y registrar en el cuaderno de campo no están disponibles",
    actionsBlockedBody: "Estas cifras son demanda hídrica modelada del cultivo, no un objetivo de aplicación de riego revisado. Guardarlas como plan de riego, o registrarlas como agua aplicada en el cuaderno de campo, tergiversaría lo que realmente ocurrió en campo.",
    basalTranspiration: "Transpiración Basal",
    soilEvaporation: "Evaporación del Suelo",
    waterStressFactor: "Factor de Estrés Hídrico",
    perHaPerDay: "mm/día por ha",
    estimatedCropWaterDemandHelperDual: "Evapotranspiración del cultivo (ETc) calculada por el balance FAO-56 Kc Dual. Es el agua que el modelo estima que consume el cultivo, no cuánto regar.",
    blockedTitle: "Plan de riego bloqueado",
    blockedInvalidEtc: "Salida FAO-56 inválida (ETc / Kc / ET₀). Revisar ciclo del cultivo, fecha de siembra/cosecha y parámetros FAO-56.",
    lifecycleReviewRequired: "Ciclo del cultivo excedido — confirmar estado de cosecha o ciclo del cultivo actual.",
    satLowButAtmHigh: "Estrés satelital bajo, pero demanda atmosférica elevada.",
    satHighAndAtmHigh: "Estrés satelital alto y demanda atmosférica elevada."
  },
  soilWaterBalance: {
    title: "Balance Hídrico del Suelo (FAO-56 Cap. 8)",
    subtitle: "Modelo AquaCrop simplificado: capacidad de campo, punto de marchitez y recarga por lluvia",
    soilType: "Tipo de suelo",
    period: "Período",
    calculate: "Calcular",
    sand: "Arena",
    sandyLoam: "Franco-arenoso",
    loam: "Franco",
    siltLoam: "Franco-limoso",
    clayLoam: "Franco-arcilloso",
    clay: "Arcilla",
    days14: "14 días",
    days30: "30 días",
    days60: "60 días",
    currentMoisture: "Humedad actual",
    stressCoefficient: "Coef. estrés (Ks)",
    daysToStress: "Días hasta estrés",
    now: "Ahora",
    irrigationNeeded: "Riego necesario",
    toReplenishRAW: "para reponer RAW",
    noStress: "Sin estrés",
    mildStress: "Estrés leve",
    moderateStress: "Estrés moderado",
    severeStress: "Estrés severo",
    soilMoisture: "Humedad suelo (mm)",
    precipitation: "Precipitación (mm)",
    adjustedETc: "ETc ajustada (mm)",
    irrigation: "Riego (mm)",
    waterStressCoefficient: "Coeficiente de Estrés Hídrico (Ks)",
    fao56Chapter8Model: "Modelo FAO-56 Capítulo 8",
    modelledReferenceBadge: "Referencia modelada",
    modelledReferenceNotice: "Referencia modelada — no es evidencia canónica de balance hídrico. Los valores proceden de un modelo diario con supuestos declarados y requieren revisión humana.",
    tawProvenanceLabel: "Origen de la capacidad hídrica (TAW)",
    tawProvenanceUnknown: "Sin procedencia canónica registrada",
    soil: "Suelo",
    stressDays: "Días con estrés",
    of: "de",
    totalETc: "ETc total",
    totalPrecipitation: "Precipitación"
  },
  recommendationActions: {
    saved: "Guardada ✓",
    saveRecommendation: "Guardar Recomendación",
    registeredInNotebook: "Registrada en Cuaderno ✓",
    registerInNotebook: "Registrar en Cuaderno de Campo",
    saveFirst: "Guarda primero para registrar en el cuaderno"
  },
  weatherProvenance: {
    title: "Evidencia meteorológica",
    mixed: "Fuentes combinadas",
    fallback: "Fuente alternativa utilizada",
    fallbackShort: "Alternativa",
    limited: "Datos meteorológicos limitados",
    modelled: "Modelizado / reanálisis",
    notAvailable: "No disponible",
    showDetails: "Ver fuente por medición",
    hideDetails: "Ocultar detalle de fuentes",
    unknown: {
      title: "Fuente meteorológica no registrada",
      body: "Este cálculo es anterior al registro de procedencia por variable, por lo que se desconoce la fuente de cada medición.",
    },
    variable: {
      tmax: "Temperatura máxima",
      tmin: "Temperatura mínima",
      tmean: "Temperatura media",
      humidity: "Humedad relativa",
      humidityMin: "Humedad relativa mínima (RHmin)",
      wind: "Velocidad del viento (2 m)",
      radiation: "Radiación solar",
      elevation: "Altitud",
      precipitation: "Precipitación",
    },
  },
  et0Plausibility: {
    title: "Evapotranspiración de referencia (ETo)",
    raw: "ETo calculada",
    effective: "Valor utilizado",
    notUsed: "No utilizada",
    capApplied: "Límite explícito aplicado",
    reviewNote: "ETo elevada — se recomienda revisión.",
    blockedNote: "Valor extremo — no se utiliza en Dual Kc hasta validar la evidencia meteorológica.",
    reasons: "Contexto",
    status: {
      plausible: "Plausibilidad: Normal",
      elevated: "ETo elevada — se recomienda revisión",
      extremeReview: "Valor extremo — revisión requerida",
      implausible: "Valor no plausible",
      invalid: "Valor inválido",
    },
    unknown: {
      title: "Plausibilidad de ETo no registrada",
      body: "Este cálculo es anterior a la política de plausibilidad de ETo, por lo que no se registraron por separado el valor calculado y el valor utilizado.",
      capUnknown: "Este cálculo es anterior a la política de plausibilidad. No se puede determinar si su valor quedó limitado por el techo anterior, por lo que se desconoce el valor calculado original.",
    },
  },
  dualKcCoreEvidence: {
    title: "Procedencia de las entradas principales",
    soil: "Textura del suelo",
    precipitation: "Precipitación",
    phenology: "Edad del cultivo",
    days: "{{count}} días desde la siembra",
    parameterNote: "REW/TEW son parámetros publicados del modelo seleccionados por textura, no valores medidos en la parcela.",
    unknown: {
      title: "Procedencia de las entradas principales no registrada",
      body: "Este cálculo es anterior al contrato de evidencia principal, por lo que no se registraron las fuentes de textura del suelo, precipitación y edad del cultivo.",
    },
  },
  // FAO56-DUAL-KC-RUNOFF-EFFECTIVE-RAIN-POLICY-1
  // FAO56-DUAL-KC-SOIL-EVAPORATION-STATE-1
  // FAO56-DUAL-KC-CROP-HEIGHT-EVIDENCE-1
  cropHeight: {
    title: "Altura de cultivo usada en el ajuste climático",
    height: "Altura",
    source: "Origen",
    evidenceType: "Evidencia",
    stage: "Estado fenológico",
    range: "Rango de referencia",
    observedAt: "Registrada el",
    policy: "Política de selección",
    notKnown: "no conocida",
    unknown: {
      title: "Procedencia de la altura de cultivo no registrada",
    },
    legacy: {
      legacy_height_provenance_unknown: "Este cálculo es anterior al contrato de evidencia de altura de cultivo, por lo que no puede mostrarse si la altura fue medida, declarada o un valor por defecto.",
      no_height_recorded: "No se registró ninguna altura de cultivo en este cálculo.",
    },
    missing: {
      title: "Altura de cultivo no disponible",
      body: "El ajuste climático no pudo calcularse porque no existe evidencia de altura de cultivo para esta parcela. No se asumió ninguna altura genérica.",
    },
    sourceValue: {
      producer_measured: "medida en campo",
      producer_declared: "declarada por el productor",
      crop_stage_reference: "referencia FAO-56 del cultivo (según estado)",
      crop_reference: "referencia FAO-56 del cultivo",
      none: "sin origen",
    },
    evidenceTypeValue: {
      measured: "medición",
      declared: "declaración",
      reference: "valor de referencia",
      modelled: "valor modelado",
      none: "ninguna",
    },
    quality: {
      high: "calidad alta",
      medium: "calidad media",
      limited: "confianza limitada",
      unavailable: "no disponible",
    },
    policyValue: {
      producer_value_as_reported: "valor del productor tal como fue informado",
      fao56_table12_single_value: "valor publicado en la Tabla 12 de FAO-56",
      fao56_table12_conservative_min: "rango de la Tabla 12 de FAO-56, límite inferior conservador",
    },
    limitation: {
      declared_by_producer_not_instrument_measured: "Declarada por el productor, no medida con instrumento.",
      declaration_date_unknown: "Se desconoce la fecha de la declaración.",
      declaration_older_than_21_days: "La declaración tiene más de tres semanas.",
      crop_specific_reference_height_not_a_parcel_measurement: "Altura de referencia del cultivo, no una medición de la parcela.",
      tabulated_height_is_representative_of_the_mid_season_stage: "La altura tabulada representa el estado de media estación.",
      stage_is_early_so_reference_height_likely_overstates_actual_height: "El cultivo está en un estado temprano, por lo que la altura de referencia probablemente sobreestima la real.",
      growth_stage_unknown_so_stage_specific_height_could_not_be_applied: "Estado fenológico desconocido: no se aplicó una altura específica por estado.",
      crop_type_has_no_approved_crop_height_reference: "Este tipo de cultivo no tiene una referencia de altura aprobada.",
      crop_type_is_a_category_not_a_crop_so_no_reference_height_applies: "El tipo de cultivo es una categoría, no un cultivo, por lo que no aplica ninguna altura de referencia.",
      producer_height_rejected_by_validation: "La altura del productor almacenada no superó la validación.",
      no_generic_crop_height_is_assumed: "No se asume ninguna altura de cultivo genérica.",
    },
  },
  depletionFraction: {
    title: "Procedencia de la fracción de agotamiento (p)",
    p: "p utilizado",
    basePValue: "Valor de tabla (ETc ≈ 5 mm/día)",
    source: "Origen",
    policy: "Selección",
    adjustment: "Ajuste por demanda atmosférica",
    adjustmentApplied: "aplicado ({{etc}} mm/día, Δp {{delta}})",
    adjustmentNotApplied: "no aplicado",
    unknown: {
      title: "Procedencia de la fracción de agotamiento no registrada",
      body: "Este cálculo es anterior al contrato de fracción de agotamiento, por lo que no se registró el origen del umbral de estrés.",
    },
    status: {
      selected: "referencia de cultivo",
      missing: "no disponible",
      invalid: "no utilizable",
      blocked: "bloqueado",
    },
    sourceValue: {
      fao56_crop_reference: "referencia de cultivo FAO-56 Tabla 22",
      project_reference: "referencia del proyecto",
      producer_parameter: "parámetro del productor",
      none: "sin origen",
    },
    policyValue: {
      fao56_table22_crop_value: "valor publicado para este cultivo",
      fao56_table22_group_value: "valor publicado para el grupo de cultivos",
      fao56_table22_conservative_min: "límite inferior del rango publicado",
    },
    quality: {
      high: "alta",
      medium: "media",
      limited: "limitada",
      unavailable: "no disponible",
    },
    limitation: {
      tabulated_p_is_a_crop_level_reference_not_a_stage_specific_or_parcel_specific_value:
        "El p tabulado es una referencia de cultivo, no un valor por estado fenológico ni por parcela.",
      etc_under_standard_conditions_unavailable_so_the_table22_demand_adjustment_was_not_applied:
        "La demanda hídrica en condiciones estándar no estaba disponible, por lo que no se aplicó el ajuste por demanda.",
      adjusted_p_limited_by_the_published_0_1_to_0_8_bounds:
        "El p ajustado quedó limitado por los límites publicados 0,1–0,8.",
      group_level_reference_less_specific_than_a_named_crop_value:
        "Se usó una referencia de grupo porque este cultivo no aparece individualmente.",
      crop_type_has_no_approved_depletion_fraction_reference:
        "Este cultivo no tiene una referencia de fracción de agotamiento aprobada.",
      crop_type_is_a_category_not_a_crop_so_no_reference_depletion_fraction_applies:
        "El tipo de cultivo es una categoría, no un cultivo, por lo que no aplica ninguna fracción de referencia.",
      no_generic_depletion_fraction_is_assumed: "No se asume ninguna fracción de agotamiento genérica.",
      resolved_depletion_fraction_outside_the_valid_open_interval_0_1:
        "La fracción de agotamiento resuelta quedó fuera de su rango válido.",
    },
  },
  soilEvaporationState: {
    title: "Estado de evaporación de la superficie del suelo",
    de: "Agotamiento superficial (inicio del día)",
    capacity: "REW / TEW",
    source: "Origen",
    sourceDate: "Fecha de referencia",
    previousEvaporation: "Evaporación del día anterior",
    previousInfiltration: "Agua aportada el día anterior",
    rejection: "No disponible porque",
    notKnown: "no conocido",
    unknown: {
      title: "Estado de evaporación superficial no registrado",
      body: "Este cálculo es anterior al contrato de estado de la capa superficial, por lo que no se registró el origen del estado de evaporación del suelo.",
    },
    status: {
      propagated: "arrastrado desde ayer",
      initialized: "inicializado con evidencia",
      limited_initialization: "punto de partida declarado",
      missing: "no disponible",
      invalid: "no utilizable",
      blocked: "bloqueado",
    },
    sourceValue: {
      previous_dual_kc_state: "balance diario anterior",
      confirmed_full_wetting: "humectación completa confirmada de la superficie",
      none: "sin origen",
    },
    reason: {
      previous_state_missing: "no existe estado superficial diario previo ni evento de humectación confirmado",
      previous_state_invalid: "el estado superficial previo está incompleto o fuera de límites físicos",
      previous_state_legacy_untrusted: "el registro previo es anterior al contrato de evidencia",
      tew_incompatible: "la capacidad de la capa evaporante cambió de forma relevante",
      temporal_gap: "hay un hueco en la serie diaria",
      previous_state_read_failed: "no se pudo leer el estado previo",
      previous_irrigation_unknown: "se desconoce el riego aplicado ayer",
      previous_rain_water_unavailable: "no se pudo resolver la lluvia de ayer",
      previous_wetted_fraction_unknown: "se desconoce la fracción de suelo humedecida ayer",
      previous_evaporation_unknown: "no se registró la evaporación de ayer",
      invalid_tew_or_rew: "los parámetros de la capa evaporante no son utilizables",
    },
    quality: {
      high: "confianza alta",
      medium: "confianza media",
      limited: "confianza limitada",
      unavailable: "no disponible",
    },
  },
  rainWater: {
    title: "Lluvia que entra en el balance",
    precipitation: "Lluvia (observada)",
    source: "Proveedor",
    runoff: "Escorrentía",
    effective: "Agua que entra en el balance",
    method: "Método",
    notKnown: "no conocido",
    unknown: {
      title: "Trazabilidad del balance de lluvia no registrada",
    },
    legacy: {
      legacy_fixed_effective_rain_assumption:
        "Este cálculo usó la suposición anterior de una fracción fija de lluvia efectiva. Esa suposición ya no se aplica y esta fila histórica no se ha reescrito.",
      legacy_effective_rain_policy_unknown:
        "Este cálculo es anterior al contrato de política de lluvia/escorrentía, por lo que la lluvia que entró en el balance no tiene trazabilidad registrada.",
    },
    runoffStatus: {
      measured: "medida",
      modelled: "modelizada",
      assumed_zero: "cero (no se registró lluvia)",
      unknown: "no modelizada",
    },
    effectiveStatus: {
      derived: "derivada",
      modelled: "modelizada",
      same_as_precipitation: "igual a la lluvia observada",
      unknown: "no conocida",
    },
    methodValue: {
      direct_precipitation: "lluvia observada usada directamente",
      measured_runoff: "escorrentía medida",
      modelled_runoff: "escorrentía modelizada",
      effective_rain_policy: "política de lluvia efectiva",
      unknown: "no disponible",
    },
    quality: {
      high: "confianza alta",
      medium: "confianza media",
      limited: "confianza limitada",
      unavailable: "no disponible",
    },
  },
  irrigationEvidence: {
    title: "Riego aplicado",
    amount: "Cantidad",
    occurrence: "Hubo riego",
    yes: "confirmado",
    notConfirmed: "no confirmado",
    unknownAmount: "desconocida",
    recordedAs: "Registrado como",
    safeNextStep: "Siguiente paso seguro",
    unknown: {
      title: "Origen del riego aplicado no registrado",
      body: "Este cálculo es anterior al contrato de evidencia de riego aplicado, por lo que no se registró el origen de la lámina de riego."
    },
    status: {
      measured: "medido",
      observed: "observado",
      confirmed: "confirmado por el productor",
      declared: "declarado por el productor",
      unknown_amount: "cantidad desconocida",
      confirmed_no_irrigation: "sin riego confirmado",
      planned: "solo planificado",
      missing: "sin registro",
      invalid: "no utilizable"
    },
    source: {
      irrigation_event: "registro de riego",
      producer_declaration: "declaración del productor",
      flow_meter: "caudalímetro",
      controller: "controlador de riego",
      farmops_confirmation: "confirmación del productor",
      field_activity: "cuaderno de campo",
      none: "sin fuente"
    },
    quality: {
      high: "calidad alta",
      medium: "calidad media",
      limited: "calidad limitada",
      unavailable: "no disponible"
    }
  },
  rootZoneDepletion: {
    title: "Estado de agua en la zona radicular",
    depletion: "Agotamiento",
    capacity: "Capacidad",
    from: "Arrastrado desde",
    rejected: "Estado no utilizado",
    safeNextStep: "Siguiente paso seguro",
    status: {
      propagated: "Arrastrado del día anterior",
      initialized: "Inicializado con evidencia",
      limited_initialization: "Inicialización limitada",
      missing: "Sin estado disponible",
      invalid: "Estado no utilizable",
      blocked: "Bloqueado",
    },
    source: {
      previous_dual_kc_state: "Estado diario anterior",
      measured_soil_moisture: "Humedad de suelo medida",
      water_balance_initialization: "Inicialización del balance hídrico",
      producer_declared_state: "Declarado por el productor",
      none: "Sin fuente",
    },
    quality: {
      high: "Confianza alta",
      medium: "Confianza media",
      limited: "Limitada",
      unavailable: "No disponible",
    },
    reason: {
      previous_state_missing: "no existe un estado diario anterior",
      previous_state_invalid: "el estado anterior está incompleto o fuera de rango",
      previous_state_legacy_untrusted: "el registro anterior no tiene trazabilidad verificable",
      taw_incompatible: "la capacidad de agua del suelo cambió de forma relevante",
      temporal_gap: "hay un hueco en la cadena de estados diarios",
      previous_state_read_failed: "no se pudo leer el estado anterior",
      previous_state_blocked: "el estado anterior estaba bloqueado",
      invalid_taw_or_raw: "los valores de almacenamiento radicular no son utilizables",
    },
    unknown: {
      title: "Trazabilidad del estado hídrico no registrada",
      body: "Este cálculo es anterior al contrato de estado hídrico, por lo que no se registró el origen del agotamiento radicular.",
    },
  },
  gauchoWaterTimeline: {
    title: "Balance hídrico en el tiempo",
    coverage: "{{computed}}/{{total}} días con estado",
    latest: "Último estado",
    depleted: "agotado",
    unknown: "No disponible",
    continuousDays: "Cadena continua",
    days: "{{count}} días",
    noChain: "Sin cadena continua",
    trend: "Tendencia",
    gaps: "Días sin estado",
    notReadable:
      "No hay suficiente estado diario continuo para leer una tendencia de estrés hídrico. Los días ausentes se muestran como huecos y nunca se estiman.",
    disclaimer:
      "Histórico de solo lectura de estados ya calculados. Los huecos no se interpolan y no se ejecuta ningún riego.",
    status: {
      computed: "Calculado",
      legacy: "Registro heredado",
      blocked: "Bloqueado por falta de evidencia",
      gap: "Sin estado registrado",
    },
    trendValue: {
      increasing_depletion: "Agotamiento en aumento",
      decreasing_depletion: "Agotamiento en descenso",
      stable: "Estable",
      unknown: "Aún no interpretable",
    },
  },
  gauchoTaw: {
    title: "Capacidad de agua en la zona radicular",
    taw: "Capacidad de agua en la zona radicular",
    source: "Fuente",
    rootDepth: "Profundidad radicular",
    quality: "Calidad de la evidencia",
    technicalDetails: "Detalles tecnicos",
    sourceRecord: "Registro de origen",
    distance: "Distancia",
    depth: "Profundidad de muestreo",
    fcwp: "CC / PMP",
    contract: "Contrato",
    quality_high: "Alta",
    quality_medium: "Media",
    quality_limited: "Limitada",
    quality_unavailable: "No registrada",
    sourceName: {
      producer_lab: "Analitica de laboratorio del productor",
      producer_field: "Muestra de campo del productor",
      lucas: "Referencia de suelo LUCAS",
      soilgrids: "Referencia modelizada SoilGrids",
      none: "No disponible"
    },
    summary: {
      producer_lab: "Segun la analitica de suelo de la parcela, la capacidad de agua disponible en la zona radicular es de aproximadamente {{taw}} mm.",
      producer_field: "Segun la muestra de campo declarada por el productor para esta parcela, la capacidad de agua disponible en la zona radicular es de aproximadamente {{taw}} mm.",
      lucas: "SentinelCrop esta usando una referencia de suelo LUCAS para esta parcela; el modelo estima la capacidad de agua disponible en la zona radicular en aproximadamente {{taw}} mm.",
      soilgrids: "SentinelCrop esta usando una referencia de suelo modelizada de SoilGrids para esta parcela; el modelo estima la capacidad de agua disponible en la zona radicular en aproximadamente {{taw}} mm.",
      blocked: "No se ha podido establecer la capacidad de agua de la zona radicular con la evidencia disponible.",
      invalid: "La capacidad de agua registrada no corresponde al contexto actual de la parcela, por lo que no se usa como evidencia vigente.",
      legacy: "Este registro es anterior al contrato de trazabilidad del suelo, por lo que su origen no esta disponible (registro heredado)."
    }
  },
  tawProvenance: {
    title: "Fuente de capacidad de agua del suelo",
    referenceOnly: "Solo referencia",
    modelled: "Modelizado",
    legacy: "Registro heredado",
    taw: "TAW",
    rootDepth: "Profundidad radicular",
    rootDepthReference: "referencia",
    depth: "Profundidad de muestreo",
    distance: "Distancia a la fuente",
    source: {
      producerLab: "Analitica de laboratorio del productor",
      producerField: "Muestra de campo del productor",
      lucas: "Muestra de referencia LUCAS",
      soilgrids: "Referencia modelizada SoilGrids"
    },
    unavailable: {
      title: "Fuente de capacidad de agua del suelo no registrada",
      body: "Este calculo no tiene procedencia verificable de la capacidad de agua del suelo, por lo que se conserva solo para auditoria."
    }
  },
  kcbClimate: {
    title: "Ajuste climatico del coeficiente de cultivo",
    unavailable: "no disponible",
    applied: "Correccion climatica local aplicada (FAO-56 Ec. 70 / Ec. 72).",
    notApplied: "Se usa el coeficiente de referencia FAO-56 sin ajuste climatico local.",
    baseKcb: "Kcb de referencia",
    selectedKcb: "Kcb utilizado",
    kcMax: "Kc max utilizado",
    etoMethod: "Metodo de ETo",
    rhmin: "HRmin",
    u2: "Viento a 2 m",
    height: "Altura del cultivo",
    stage: "Etapa",
    unknown: {
      title: "Procedencia climatica del coeficiente no registrada",
    },
    legacy: {
      legacy_climate_adjustment_assumption: "Este calculo uso el supuesto historico HR = 60 % / u2 = 2 m/s; no estaba respaldado por evidencia.",
      legacy_climate_adjustment_provenance_unknown: "Este calculo es anterior al contrato de ajuste climatico, por lo que no consta si se aplico correccion climatica local.",
    },
    status: {
      adjusted: "Ajustado al clima",
      tabulated_unadjusted: "Valor de referencia",
      limited: "Limitado",
      missing: "Ausente",
      invalid: "No valido",
      blocked: "Bloqueado",
    },
    quality: { high: "Alta", medium: "Media", limited: "Limitada", unavailable: "No disponible" },
    eto: { penman_monteith: "Penman-Monteith", hargreaves_samani: "Hargreaves-Samani", unknown: "Desconocido" },
    stageName: { initial: "Inicial", development: "Desarrollo", mid_season: "Media estacion", late_season: "Final de estacion", unknown: "Desconocida" },
    limitation: {
      rhmin_unavailable_no_humidity_evidence: "No hay evidencia de humedad para esta fecha.",
      rhmin_unavailable_humidity_is_rhmean: "Solo hay humedad relativa media; FAO-56 requiere la minima.",
      rhmin_unavailable_humidity_is_rhmax: "Solo hay humedad relativa maxima; FAO-56 requiere la minima.",
      rhmin_unavailable_humidity_is_unspecified: "No se declara el tipo de variable de humedad, por lo que no puede usarse como HRmin.",
      rhmin_invalid_out_of_range: "La humedad minima informada esta fuera del rango valido.",
      u2_unavailable_no_wind_evidence: "No hay evidencia de viento para esta fecha.",
      u2_unavailable_wind_height_unknown: "Se desconoce la altura de medicion del viento, por lo que no puede usarse una velocidad a 2 m.",
      u2_invalid_out_of_range: "La velocidad del viento informada esta fuera del rango valido.",
      crop_height_unavailable_for_climate_adjustment: "No hay evidencia de altura de cultivo.",
      kcb_not_climate_adjusted_to_local_conditions: "El Kcb es el valor de referencia FAO-56, no ajustado al clima local.",
      kcmax_not_climate_adjusted_to_local_conditions: "El Kc max usa la forma de clima de referencia FAO-56 max(1,2; Kcb + 0,05).",
      kcb_below_045_not_climate_corrected_per_fao56: "FAO-56 no corrige valores de Kcb iguales o inferiores a 0,45.",
      kcb_initial_stage_not_climate_corrected_per_fao56: "FAO-56 no aplica correccion climatica al Kcb de la etapa inicial.",
      base_kcb_invalid: "No se pudo establecer un Kcb de referencia valido.",
    },
  },
  evidenceBlocker: {
    heading: "El balance hídrico necesita más información",
    technicalDetails: "Detalles técnicos",
    codeLabel: "Código canónico",
    gate: "Puerta de evidencia",
    contract: "Contrato de evidencia",
    date: "Fecha de cálculo",
    httpStatus: "Estado",
    savedNote: "Evidencia guardada. El próximo cálculo la utilizará; no se recalcula nada automáticamente.",
    severity: {
      blocking: "Bloqueante",
      limited: "Evidencia limitada",
      warning: "Contexto incompleto",
      system_error: "Incidencia técnica",
    },
    action: {
      confirm_full_wetting: "Confirmar humedecimiento de la superficie",
      declare_root_zone_depletion: "Aportar referencia inicial de la zona radicular",
      record_irrigation: "Añadir la cantidad aplicada",
      confirm_no_irrigation: "Confirmar el estado de riego",
      confirm_crop: "Confirmar el cultivo",
      enter_crop_height: "Añadir la altura del cultivo",
      declare_wetted_fraction: "Indicar la fracción de suelo mojada",
      update_irrigation_system: "Confirmar el sistema de riego de la parcela",
      wait_for_weather: "Esperar evidencia meteorológica",
      retry_later: "Reintentar más tarde",
      contact_support: "Contactar con soporte",
      none: "No requiere acción",
    },
    code: {
      blocked_missing_wetted_fraction_evidence: {
        title: "No está documentada la fracción de suelo mojada",
        body: "FAO-56 necesita la fracción de superficie de suelo mojada por el riego (fw). No se asume ningún valor a partir del tipo de sistema de riego, por lo que el cálculo de Kc dual no se ejecuta hasta que exista evidencia medida o declarada.",
      },
      blocked_missing_irrigation_system_evidence: {
        title: "Se desconoce el sistema de riego de esta parcela",
        body: "Sin un sistema de riego documentado no hay base para la fracción de suelo mojada. Un sistema desconocido nunca se interpreta como aspersión.",
      },
      blocked_invalid_wetted_fraction_evidence: {
        title: "La fracción de suelo mojada registrada no es válida",
        body: "El valor almacenado está fuera del rango físico (0 a 1) o no es numérico, por lo que no se utiliza.",
      },
      blocked_conflicting_wetted_fraction_evidence: {
        title: "Registros contradictorios de fracción de suelo mojada",
        body: "Varios registros del mismo rango indican fracciones distintas para esta fecha. El conflicto debe resolverse antes de ejecutar el cálculo.",
      },
      blocked_missing_soil_evaporation_state: {
        title: "El balance hídrico necesita una referencia inicial de agua en superficie",
        body: "No existe una referencia inicial para la capa superficial del suelo. Si hoy la superficie se humedeció por completo (lluvia intensa o riego completo), puede confirmarlo para inicializar el modelo.",
      },
      blocked_missing_root_zone_depletion: {
        title: "El agua de la zona radicular necesita una referencia inicial",
        body: "El balance de la zona radicular no puede iniciarse sin una primera referencia fiable. Solo se ofrecen opciones aprobadas; no se asume nada por usted.",
      },
      blocked_missing_irrigation_amount: {
        title: "La evidencia de riego está incompleta para esta fecha",
        body: "El balance hídrico todavía no dispone de evidencia fiable sobre la cantidad de riego aplicada en esta fecha. Una cantidad ausente nunca se interpreta como cero.",
      },
      blocked_missing_irrigation_evidence: {
        title: "Se desconoce el riego de esta fecha",
        body: "SentinelCrop no puede determinar si hubo riego en esta fecha. Puede registrar lo ocurrido o confirmar que no se regó.",
      },
      blocked_missing_crop_height_evidence: {
        title: "Se necesita la altura del cultivo para el ajuste climático local",
        body: "No hay altura medida, declarada ni de referencia disponible para este cultivo y estado.",
      },
      blocked_missing_depletion_fraction: {
        title: "No hay referencia FAO-56 de estrés hídrico para este cultivo",
        body: "No existe una referencia FAO-56 soportada para este cultivo. Confirmar la identidad del cultivo puede resolverlo.",
      },
      blocked_missing_root_depth: {
        title: "No hay referencia FAO-56 de profundidad radicular para este cultivo",
        body: "El cultivo no dispone de una referencia de profundidad radicular soportada. Confirmar la identidad del cultivo puede resolverlo.",
      },
      blocked_missing_crop_kc_reference: {
        title: "No hay curva FAO-56 de coeficiente de cultivo para este cultivo",
        body: "Este tipo de cultivo no corresponde a una curva Kc FAO-56 aprobada, por lo que no se asumió ningún coeficiente de cultivo. Confirmar la identidad del cultivo en la parcela puede resolverlo.",
      },
      blocked_missing_phenology_evidence: {
        title: "Se desconoce el estado fenológico",
        body: "No hay un estado del cultivo observado para esta fecha, por lo que no pueden seleccionarse coeficientes por etapa.",
      },
      blocked_missing_taw: {
        title: "No se pudo establecer la capacidad de agua de la zona radicular",
        body: "La evidencia de suelo disponible no basta para establecer la capacidad de agua radicular. Depende de datos de referencia de suelo, no de información que usted pueda aportar en campo.",
      },
      invalid_taw: {
        title: "La capacidad de agua radicular no es utilizable",
        body: "La evidencia de suelo disponible produjo un valor de capacidad no utilizable. Es un problema de datos, no una observación de campo que deba aportar.",
      },
      blocked_missing_soil_texture_evidence: {
        title: "No hay evidencia de textura del suelo",
        body: "No existe textura de suelo respaldada por una fuente para esta parcela, por lo que no pueden derivarse los parámetros hídricos.",
      },
      blocked_missing_et0: {
        title: "No hay evapotranspiración de referencia disponible",
        body: "No existe una evapotranspiración de referencia válida para esta fecha. Se resuelve cuando se publique la evidencia meteorológica.",
      },
      blocked_missing_et0_inputs: {
        title: "La evidencia meteorológica está incompleta",
        body: "Faltan variables meteorológicas necesarias para calcular la evapotranspiración de referencia en esta fecha.",
      },
      blocked_missing_climate_inputs: {
        title: "No hay evidencia meteorológica disponible",
        body: "Ningún proveedor entregó evidencia meteorológica utilizable para esta fecha y ubicación.",
      },
      blocked_missing_precipitation_evidence: {
        title: "No hay evidencia de precipitación",
        body: "Se desconoce la lluvia de esta fecha, y una lluvia desconocida nunca se trata como cero.",
      },
      blocked_missing_rain_water_evidence: {
        title: "No hay evidencia del balance de agua de lluvia",
        body: "No puede establecerse la aportación de la lluvia al balance hídrico en esta fecha.",
      },
      blocked_missing_kcb_climate_policy: {
        title: "No se pudo resolver la política de coeficiente de cultivo",
        body: "No se pudo resolver la política de coeficiente de cultivo para esta fecha. Lo gestiona la plataforma.",
      },
      blocked_invalid_phenology_evidence: {
        title: "Las fechas de cultivo registradas no son utilizables",
        body: "Las fechas de siembra o de cultivo registradas son incoherentes para esta fecha, por lo que no puede establecerse el estado fenológico. Confirmar el cultivo y sus fechas puede resolverlo.",
      },
      blocked_invalid_evidence: {
        title: "La evidencia de agua en el suelo no es utilizable",
        body: "Existe evidencia de suelo para esta parcela pero no supera las comprobaciones de capacidad hídrica. Es un problema de datos, no una observación de campo que deba aportar.",
      },
      blocked_implausible_et0: {
        title: "La evapotranspiración de referencia está fuera del rango plausible",
        body: "La evapotranspiración calculada con la evidencia meteorológica disponible no es plausible, por lo que no se produjo balance hídrico. El valor bruto se conservó sin recortar.",
      },
      blocked_et0_review_required: {
        title: "La evapotranspiración de referencia requiere revisión",
        body: "La evapotranspiración calculada para esta fecha es extrema y queda en revisión antes de poder usarse. No falta información de campo por su parte.",
      },
      limited_kcb_tabulated_unadjusted: {
        title: "Se usan coeficientes de cultivo de referencia FAO-56",
        body: "El ajuste climático local no está disponible porque falta la humedad mínima o el viento. El cálculo continúa con valores tabulados de referencia.",
      },
      limited_crop_height_reference: {
        title: "La altura del cultivo usa un valor de referencia FAO-56",
        body: "La altura utilizada es un valor de referencia, no una medición de campo.",
      },
      limited_declared_root_zone_depletion: {
        title: "El agotamiento radicular fue declarado por el productor",
        body: "La referencia inicial es una declaración, por lo que la calidad de evidencia es limitada frente a una medición.",
      },
      limited_runoff_unknown: {
        title: "La escorrentía es desconocida",
        body: "No pudo establecerse la escorrentía, por lo que la lluvia efectiva se reporta sin deducción.",
      },
      limited_weather_fallback_provider: {
        title: "La evidencia meteorológica procede de un proveedor alternativo",
        body: "El proveedor preferente no estaba disponible; la evidencia meteorológica canónica sigue siendo válida.",
      },
      system_error: {
        title: "SentinelCrop no pudo completar este cálculo",
        body: "Un error técnico impidió el cálculo. No falta información de campo por su parte.",
      },
    },
  },
  irrigationWaterState: {
    title: "Estado canónico del agua en el suelo (FAO-56 Kc Dual)",
    unavailable: "No disponible",
    noCanonicalRow: "No existe un resultado canónico del balance FAO-56 Kc Dual para esta parcela y fecha.",
    systemError: "No se pudo leer el estado canónico del balance hídrico.",
    etcLabel: "Evapotranspiración del cultivo (ETc)",
    etcEquivalent: "Equivale a ~{{value}} m³/ha/día de uso de agua modelado del cultivo",
    drLabel: "Agotamiento de la zona radicular (Dr)",
    drEquivalent: "Equivalente de déficit de almacenamiento: ~{{value}} m³/ha",
    rawLabel: "Agua fácilmente disponible (RAW)",
    tawLabel: "Agua total disponible (TAW)",
    ksLabel: "Coeficiente de estrés (Ks)",
    statusLabel: "Umbral de manejo",
    thresholdNotReached: "Dr está por debajo de RAW — no se ha alcanzado el agotamiento permitido de manejo",
    thresholdReached: "Dr alcanzó o superó RAW — se ha alcanzado el agotamiento permitido de manejo",
    stressActive: "Estrés hídrico canónico activo (Ks < 1)",
    stressInactive: "Sin estrés hídrico canónico (Ks = 1)",
    applicationTargetLabel: "Acciones de aplicación de riego",
    applicationTargetBlocked: "Las acciones legacy de guardar y registrar en campo permanecen deshabilitadas. ETc y Dr no son cantidades a aplicar. Cualquier objetivo NETO canónico supervisado se muestra por separado y permanece sujeto a sus controles de evidencia.",
  },
  canonicalNetTarget: {
    captureForFieldValidation: "Capturar para validación de campo",
    capturedForFieldValidation: "Capturado para validación de campo",
    captureError: "No se pudo capturar esta decisión. No se ha guardado nada.",
    captureMeaning: "Captura esta instantánea de decisión para validación prospectiva de campo. No significa que la decisión esté validada agronómicamente ni verificada en campo.",
    title: "Objetivo neto canónico de riego (supervisado)",
    reviewRequiredBadge: "Requiere revisión humana",
    netLabel: "Objetivo NETO supervisado de agua en la zona radicular",
    isNetRootZone: "Es un objetivo NETO de agua en la zona radicular.",
    basedOnEvidence: "Basado en el estado hídrico canónico modelado FAO-56 Kc Dual y en una política de manejo revisada.",
    notGross: "NO es una lámina bruta aplicada: no se aplica eficiencia del sistema de riego.",
    notDuration: "NO es una duración ni un tiempo de riego.",
    notSchedule: "NO es una programación.",
    humanReviewRequired: "Se requiere revisión agronómica humana antes de cualquier decisión.",
    notExecutionCommand: "No es una orden de ejecución; SentinelCrop no ejecuta ninguna acción de riego.",
    notTriggeredTitle: "Umbral de manejo no alcanzado",
    notTriggeredBody: "No se propone ningún objetivo de riego.",
    notAvailable: "No disponible",
    safeNextStep: "Siguiente paso seguro: recalcular el balance hídrico canónico y confirmar la política objetivo revisada y la evidencia hídrica posterior al estado. No se muestra ningún valor numérico mientras la cadena esté bloqueada.",
    blockers: {
      unknown: "La cadena del objetivo neto canónico está bloqueada por una barrera de evidencia sin resolver.",
      system_error: "Un error técnico impidió leer la evidencia canónica.",
      missing_canonical_water_state: "No existe un estado hídrico canónico FAO-56 Kc Dual para esta parcela y día.",
      rejected_legacy_water_state: "El registro persistido del balance es evidencia heredada o no elegible.",
      invalid_decision_day: "El día de decisión no es un día calendario UTC válido.",
      no_active_crop_season: "No existe una campaña de cultivo activa para esta parcela.",
      ambiguous_active_crop_season: "Existe más de una campaña activa; la selección falla de forma cerrada.",
      missing_reviewed_policy: "No existe una política revisada de agotamiento objetivo para esta campaña.",
      ambiguous_active_policy: "Existe más de una política objetivo activa; la selección falla de forma cerrada.",
      invalid_policy_record: "El registro de la política objetivo es estructuralmente inválido.",
      policy_not_yet_valid: "La política objetivo revisada aún no es válida en este día.",
      policy_expired: "La política objetivo revisada ha caducado.",
      exact_water_state_cutoff_unavailable: "El balance hídrico no aporta un corte exacto de evidencia, por lo que no puede descartarse lluvia o riego posterior.",
      temporal_resolution_insufficient: "La resolución temporal disponible no permite ordenar los eventos hídricos respecto al estado canónico.",
      post_state_water_event_requires_recompute: "Hubo lluvia o riego después del estado canónico; el balance hídrico debe recalcularse.",
      post_state_water_event_evidence_incomplete: "La evidencia de lluvia o riego posterior es incompleta; la ausencia de evidencia nunca se interpreta como ausencia de evento.",
      stale_water_state: "El estado hídrico canónico no corresponde al día actual.",
      missing_post_state_water_event_evidence: "Falta evidencia de lluvia o riego posterior al estado.",
      missing_root_zone_depletion: "El agotamiento actual de la zona radicular (Dr) no está disponible.",
      invalid_root_zone_depletion: "El agotamiento actual de la zona radicular (Dr) no es válido.",
      management_threshold_unavailable: "El estado canónico del umbral de manejo no está disponible.",
      management_threshold_not_reached: "No se ha alcanzado el agotamiento permitido de manejo.",
      missing_taw_for_target_policy_validation: "El agua total disponible (TAW) no está disponible, por lo que la política no puede validarse.",
      invalid_taw_for_target_policy_validation: "El agua total disponible (TAW) no es válida.",
      missing_target_policy: "No se aportó una política revisada de agotamiento objetivo.",
      invalid_target_policy: "La política revisada de agotamiento objetivo no es válida para este estado.",
    },
  },
  /** FIELD-VALIDATION-PILOT-WORKFLOW-1 — flujo de validación prospectiva. */
  fieldValidation: {
    title: "Validación prospectiva en campo",
    prospectiveBadge: "Piloto — prospectivo, no validado",
    disclaimer:
      "Registra lo que se sabía al decidir, lo que decidió una persona y lo que realmente ocurrió. No es un resultado validado, ni una afirmación de precisión, ni una métrica de rendimiento.",
    snapshotOnly:
      "Se muestra desde la instantánea congelada de la decisión. Nunca se recalcula con datos nuevos.",
    loading: "Cargando decisiones capturadas…",
    noEpisodes: "Todavía no se ha capturado ninguna decisión para esta parcela.",
    netTarget: "Objetivo neto de aplicación",
    storageGap: "Déficit de almacenamiento equivalente (Dr)",
    targetDepletion: "Agotamiento objetivo revisado",
    blocker: "Bloqueo",
    none: "Ninguno",
    notAvailable: "No disponible",
    states: {
      OPEN: "Abierto",
      DECISION_CAPTURED: "Decisión capturada",
      HUMAN_REVIEWED: "Revisado por una persona",
      OUTCOME_PENDING: "Resultado pendiente",
      OUTCOME_CAPTURED: "Resultado capturado",
      CLOSED: "Cerrado",
    },
    b3Status: {
      available: "Objetivo disponible",
      not_triggered: "No activado",
      blocked: "Bloqueado",
      system_error: "Error del sistema",
    },
    reviewTitle: "Revisión humana",
    recordReview: "Registrar revisión humana",
    reviewNotesPlaceholder: "Notas opcionales sobre esta decisión",
    reviewerIdentityNote:
      "La identidad del revisor la registra la base de datos desde tu cuenta iniciada. No se puede elegir aquí.",
    reviewStatus: {
      agree: "Estoy de acuerdo con la decisión",
      partially_agree: "Estoy parcialmente de acuerdo",
      disagree: "No estoy de acuerdo",
      not_reviewed: "Sin revisar",
    },
    reviewerRole: {
      farmer: "Agricultor",
      agronomist: "Agrónomo",
      advisor: "Asesor",
      internal_test: "Prueba interna",
    },
    actionTitle: "Acción real en campo",
    recordAction: "Registrar acción real",
    linkIrrigationEvent: "Vincular un riego real registrado (opcional)",
    linkFarmOps: "Vincular una confirmación real de campo (opcional)",
    noLinkedRecord: "Sin registro vinculado",
    declaredAmount: "Agua realmente aplicada (mm)",
    declaredAmountPlaceholder: "mm realmente aplicados",
    declaredAmountNote:
      "Es lo que TÚ aplicaste. Nunca es una recomendación ni se usa para calcular una.",
    declaredDay: "Día en que ocurrió realmente la acción",
    occurrenceNote:
      "El momento de la acción procede solo de un registro vinculado o de esta declaración. Nunca de la fecha de creación de una fila.",
    actionKind: {
      no_action: "No se hizo nada",
      irrigation_applied: "Se regó",
      irrigation_applied_unknown_depth: "Se regó, lámina desconocida",
      different_irrigation_amount: "Se regó una cantidad distinta",
      postponed: "Aplazado",
      other: "Otro",
    },
    outcomeTitle: "Evidencia posterior",
    recordOutcome: "Registrar evidencia seleccionada",
    noOutcomeAvailable: "No hay evidencia posterior disponible",
    noFollowUpCandidates:
      "No existe ningún registro posterior a esta decisión. Aun así puedes indicar que no hay evidencia disponible.",
    provenanceNote:
      "La procedencia se deriva del registro de origen. Una observación declarada nunca se presenta como una medición.",
    outcomeAvailability: {
      captured: "Capturada",
      none_available: "No disponible",
      pending: "Pendiente",
    },
    sourceType: {
      soil_moisture_observations: "Observación de humedad del suelo",
      ground_truth_measurements: "Medición de referencia en campo",
      scouting_reports: "Informe de scouting",
      gaucho_action_observation: "Observación de campo",
      iot_readings: "Lectura de sensor",
      index_time_series: "Índice satelital",
      advanced_satellite_indices: "Índice satelital",
      fao56_dual_kc_results: "Resultado de modelo",
      farmops_confirmations: "Confirmación de campo",
    },
    provenance: {
      FIELD_MEASURED: "Medido en campo",
      FIELD_OBSERVED: "Observado en campo",
      SENSOR_MEASURED: "Medido por sensor",
      SATELLITE_OBSERVED: "Observado por satélite",
      MODEL_DERIVED: "Derivado de modelo",
      USER_DECLARED: "Declarado por el usuario",
    },
    closeNote: "Cerrar no añade ningún dato nuevo. El episodio queda permanentemente en solo lectura.",
    closeEpisode: "Cerrar episodio",
    readinessTitle: "Preparación del piloto",
    readinessUnknownNote:
      "Una condición desconocida nunca cuenta como cumplida. Aquí no se infiere nada.",
    readinessStatus: {
      ready: "Listo para operar",
      not_ready: "No listo",
      satisfied: "Cumplido",
      not_satisfied: "Falta",
      unknown: "Desconocido",
    },
    readinessCheck: {
      parcel_geometry: "Límite de la parcela registrado",
      crop_identified: "Cultivo identificado",
      active_crop_season: "Exactamente una campaña activa",
      season_start_date: "Fecha de inicio de campaña registrada",
      irrigation_system_declared: "Sistema de riego declarado",
      soil_water_holding_inputs: "Parámetros medidos de retención de agua del suelo",
      root_depth_input: "Profundidad radicular declarada",
      reviewed_target_policy: "Política de agotamiento objetivo revisada",
      water_state_evidence_available: "Existe evidencia canónica de estado hídrico",
      named_reviewer: "Se ha registrado un revisor identificado",
      owner_data_access_consent: "Consentimiento del titular para usar estos datos en el piloto",
    },
    errors: {
      unknown_error: "No se pudo completar la operación.",
      not_authenticated: "Inicia sesión para operar la validación en campo.",
      episode_read_failed: "No se pudieron leer las decisiones capturadas.",
      episode_not_found: "Este episodio no es visible para tu cuenta.",
      lifecycle_state_conflict: "El episodio ya avanzó. Recarga e inténtalo de nuevo.",
      lifecycle_transition_rejected: "La base de datos rechazó esta transición.",
    },
  },
};
